import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';

// Bootstrap-CSS+JS zuerst, danach apple.css — damit Brand-Overrides (Akzent,
// Topnav etc.) gegenüber Bootstrap-Defaults gewinnen.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './styles/apple.css';

// Apache/cPanel-Quirk: bei HTTP→HTTPS-Redirect entstehen manchmal Doppel-Slashes
// (z.B. `//callback?code=...`). Vue-Router würde das als unbekannten Pfad
// behandeln. Vor dem Mount normalisieren.
if (/^\/{2,}/.test(window.location.pathname)) {
  const fixed = '/' + window.location.pathname.replace(/^\/+/, '')
               + window.location.search + window.location.hash;
  window.history.replaceState({}, '', fixed);
}

createApp(App).use(router).mount('#app');
